"use client";

import { useState, useRef, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
export default function HeroPromotion() {
  const [offsetY, setOffsetY] = useState(0);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          setOffsetY(rect.top * 0.5);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="hero-promotion" ref={sectionRef} className="relative bg-background text-foreground py-16 lg:py-24 overflow-hidden min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 lg:flex-row-reverse gap-8 lg:gap-16 items-center">
          {}
          <div className="flex flex-col justify-center space-y-6 lg:space-y-8">
            {}
            <div>
              <Badge variant="outline" className="bg-emerald-500/10 text-emerald-600 border-emerald-500/20 rounded-none uppercase tracking-widest text-[10px] font-bold px-3 py-1">
                trusted website
              </Badge>
            </div>

            {}
            <p className="font-serif text-lg sm:text-xl font-default text-muted-foreground leading-relaxed max-w-md whitespace-pre-line italic">
              Brilli<br />
              Less. Better. Brilli.<br /><br />
              Brilli este o selecție curată de produse esențiale, alese pentru design, funcționalitate și calitate fără compromis. Fiecare articol este filtrat cu intenție — doar ceea ce merită cu adevărat își găsește locul în colecția noastră.<br /><br />
              Credem în simplitate rafinată, în obiecte care nu doar completează un stil de viață, ci îl definesc discret. Fără exces. Fără zgomot. Doar produse bine gândite, create pentru a dura.<br /><br />
              Brilli înseamnă:<br />
              • Curare riguroasă a fiecărui produs<br />
              • Estetică minimalistă, atemporală<br />
              • Calitate înainte de cantitate<br />
              • Experiență de cumpărare simplificată la esență<br /><br />
              Descoperă o selecție unde fiecare detaliu contează și nimic nu este întâmplător.<br />
              Brilli — the essential refined.
            </p>

            {}
            <div>
              <Link to="/ShopPage">
                <Button className="px-8 py-3 text-base font-semibold rounded-none border-2 border-primary bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300" variant="default">
                  Shop Now
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="relative h-96 sm:h-[500px] lg:h-[600px] flex items-center justify-center">
            {}
            <div className="absolute inset-0 flex items-center justify-center" style={{
            transform: `translateY(${offsetY}px)`
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642813/img/brilli.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642813/img/brilli.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642813/img/brilli.png-wvc-sizes" alt="BRILLI Brand Showcase" className="w-full h-full object-cover rounded-lg shadow-lg" loading="lazy" />
            </div>

            {}
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/60 rounded-lg pointer-events-none" />
          </div>
        </div>
      </div>
    </section>;
}